import { TAG_CATEGORIES_ID } from "utils/tagConstants";

const CP_EXTRACTOR_KEYS = {
    NAME: "name",
    CONTROL_COUNT: "controlCount",
    STATUS: "status",
    TAGS: "tags",
    TAG_CATEGORIES: TAG_CATEGORIES_ID,
    ACCESS_RIGHTS: "accessRights",
    CONTROL_RESULT_COUNT: "controlResultCount",
    ENTITIES: "entities",
} as const;

export { CP_EXTRACTOR_KEYS };
